export default __webpack_public_path__ + "static/media/boost_async_int_mosfet.0e8774d4.svg";